/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const PropListDraggerIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>((props, ref) => {
  return (
    <BaseIcon {...props} ref={ref}>
      <svg
        data-wf-icon="PropListDraggerIcon"
        width="3"
        height="10"
        viewBox="0 0 3 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="M0 1.5H3M0 4.5H3M0 7.5H3" stroke="currentColor" />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

PropListDraggerIcon.category = 'Misc.';
